export default "__VITE_PUBLIC_ASSET__3c6e5fd6__"